
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

export class GenMemberStatus {
    static readonly PENDING: GenMemberStatus = new GenMemberStatus('PENDING');
    static readonly APPROVED: GenMemberStatus = new GenMemberStatus('APPROVED');
    static readonly DENIED: GenMemberStatus = new GenMemberStatus('DENIED');

    public readonly name: string;

    private constructor(name: string) {
        this.name = name;
    }

    static forName(name: string) {
        if (name === 'PENDING') return GenMemberStatus.PENDING;
        if (name === 'APPROVED') return GenMemberStatus.APPROVED;
        if (name === 'DENIED') return GenMemberStatus.DENIED;
        throw new Error('Unexpected value for GenMemberStatus:' + name);
    }

    static values(): GenMemberStatus[] {
        return [
            GenMemberStatus.PENDING,
            GenMemberStatus.APPROVED,
            GenMemberStatus.DENIED,
        ];
    }

    toJSON(): string {
        return this.name;
    }

    toString(): string {
        return this.name;
    }
}

